import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LogInView.vue'
import ResetView from '@/views/ResetView.vue'
import DashboardView from '@/views/DashboardView.vue'
import ConfigView from '@/views/ConfigView.vue'
import CalibrationView from '@/views/CalibrationView.vue'
import RepairNetworkView from '@/views/RepairNetworkView.vue'
import VehicleDetailsView from '@/views/VehicleDetailsView.vue'
import LocationView from '@/views/LocationView.vue'
import MemberView from '@/views/MemberView.vue'
import SsoView from '@/views/SsoView.vue'
import OpportunityView from '@/views/OpportunityView.vue'
import ProfileView from '@/views/ProfileView.vue'
import SearchShopsView from '@/views/SearchShopsView.vue'
import MarketingDashboardView from '@/views/MarketingDashboardView.vue'
import MarketingOpportunityView from '@/views/MarketingOpportunityView.vue'
import MarketingSearchShopsView from '@/views/MarketingSearchShopsView.vue'
import ProviderBillingReportView from '@/views/ProviderBillingReportView.vue'
import UploadEstimateView from '@/views/UploadEstimateView.vue'
import UploadEstimateReviewView from '@/views/UploadEstimateReviewView.vue'
import VinInspectionView from '@/views/VinInspectionView.vue'
import AdasIqView from '@/views/AdasIqView.vue'
export default [
  {
    path: '/login',
    name: 'login',
    meta: { allowAnonymous: true },
    component: LoginView
  },
  {
    path: '/sso',
    name: 'sso',
    meta: { allowAnonymous: true },
    component: SsoView
  },
  {
    path: '/reset',
    name: 'reset',
    meta: { allowAnonymous: true },
    component: ResetView
  },
  {
    path: '/',
    name: 'home',
    meta: { layout: 'side-nav' },
    component: HomeView
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { layout: 'side-nav' },
    component: ProfileView
  },
  {
    path: '/locations',
    name: 'locations',
    meta: { layout: 'side-nav' },
    component: LocationView
  },
  {
    path: '/membership',
    name: 'membership',
    meta: { layout: 'side-nav' },
    component: MemberView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { layout: 'side-nav' },
    component: DashboardView
  },
  {
    // Issue 622: upload a PDF estimate to create an ADAS inspection on behalf of a customer.
    path: '/upload-estimate',
    name: 'upload-estimate',
    meta: { layout: 'side-nav' },
    component: UploadEstimateView
  },
  {
    // VIN-only (predictive) inspection, the CCP side of ADAS Map's own VIN lookup screen.
    path: '/vin-inspection',
    name: 'vin-inspection',
    meta: { layout: 'side-nav' },
    component: VinInspectionView
  },
  {
    // Issue 622: review the firm's uploaded estimate PDFs + download.
    path: '/upload-estimate-review',
    name: 'upload-estimate-review',
    meta: { layout: 'side-nav' },
    component: UploadEstimateReviewView
  },
  {
    path: '/calibration/:firm',
    name: 'calibration',
    meta: { layout: 'side-nav' },
    component: CalibrationView
  },
  {
    path: '/repairNetwork/:firm',
    name: 'repairNetwork',
    meta: { layout: 'side-nav' },
    component: RepairNetworkView
  },
  {
    path: '/vehicle-details/:vin/:adasinspection/:camefrom/:opportunity',
    name: 'vehicle-details-opportunity',
    meta: { layout: 'side-nav' },
    component: VehicleDetailsView
  },
  {
    path: '/vehicle-details/:vin/:adasinspection/:camefrom',
    name: 'vehicle-details',
    meta: { layout: 'side-nav' },
    component: VehicleDetailsView
  },
  {
    path: '/configuration',
    name: 'configuration',
    meta: { layout: 'side-nav' },
    component: ConfigView
  },
  {
    path: '/opportunity',
    name: 'opportunity',
    meta: { layout: 'side-nav' },
    component: OpportunityView
  },
  {
    path: '/search-shops',
    name: 'searchshops',
    meta: { layout: 'side-nav' },
    component: SearchShopsView
  },
  {
    path: '/marketing-dashboard',
    name: 'marketingdashboard',
    meta: { layout: 'side-nav' },
    component: MarketingDashboardView
  },
  {
    path: '/marketing-search-shops',
    name: 'marketingsearchshops',
    meta: { layout: 'side-nav' },
    component: MarketingSearchShopsView
  },
  {
    path: '/marketing-opportunity',
    name: 'marketingopportunity',
    meta: { layout: 'side-nav' },
    component: MarketingOpportunityView
  },
  {
    path: '/reports/provider-billing',
    name: 'reportsProviderBilling',
    meta: { layout: 'side-nav' },
    component: ProviderBillingReportView
  },
  {
    // #620: ADAS IQ as a page (the ADAS IQ service's embed). Nav entry, and the
    // guard, only for users ADAS IQ allows (stores/adasIq.js).
    path: '/adas-iq',
    name: 'adas-iq',
    meta: { layout: 'side-nav' },
    component: AdasIqView
  },
  {
    path: '/about',
    name: 'about',
    meta: { layout: 'side-nav' },
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/AboutView.vue')
  }
]
